// extracted by mini-css-extract-plugin
module.exports = {"labelsWrapper":"MapLabels_labelsWrapper__3eB2_","label":"MapLabels_label__3cWjN"};